import { createReducer, on } from '@ngrx/store';
import { setTimeDicerDateRangeSelection, clearTimeDicerDateRangeSelection } from './timeDicerDateRangeSelection.actions';
import { initialTimeMonthState } from './timeDicerDateRangeSelection.state';

export const timeDicerDateRangeSelectionReducer = createReducer(
  initialTimeMonthState,
  on(setTimeDicerDateRangeSelection, (state, { week }) => ({ ...state, timeDicerDateRangeSelection : week })),
  on(clearTimeDicerDateRangeSelection, state => ({ ...state, timeDicerDateRangeSelection : null }))
);